import { createSelector } from 'reselect';

export const savedVideosSelector = createSelector(
  (state) => state.d_savedVideos,
  (savedVideos) => savedVideos
);
